import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ISCMService = ( createDecorator('scm'));
const ISCMViewService = ( createDecorator('scmView'));
export { ISCMService, ISCMViewService };
